import api from '../../utils/api'

const API_BASE_URL = "/admin/ADPUsrtnt";

const ADPUsrtntService = {
    async findAll(recordFilter: any): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all`,
            { params: recordFilter }
        );
        return response.data;
    },

    async findOne(userId: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-one/${userId}`);
        return response.data;
    },

    async create(item: any): Promise<any> {
        const response = await api.post(`${API_BASE_URL}/create`, item);
        return response.data;
    },

    async update(userId: string, item: any): Promise<any> {
        const response = await api.put(`${API_BASE_URL}/update/${userId}`, item);
        return response.data;
    },

    async delete(userId: string): Promise<any> {
        const response = await api.delete(`${API_BASE_URL}/delete/${userId}`);
        return response.data;
    },

    async getItemsByUserId(userId: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all-by-user-id/${userId}`);
        return response.data;
    },

    async getItemsExcludeFacilityCode(facilityCode: string, userId: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all-exclude/${facilityCode}/${userId}`);
        return response.data;
    },
    
};

export default ADPUsrtntService;